export default {
  riot: {
    name: "riot",
    type: 0
  },
  telegram: {
    name: "telegram",
    type: 1
  },
  is(toTest, expectedMessenger) {
    if (toTest == expectedMessenger) return true;

    if (expectedMessenger.name) {
      if (toTest == expectedMessenger.name || toTest == expectedMessenger.type) return true;
    }

    return false;
  },
  toId(name) {
    if (Number.isInteger(name)) return name;
    return name == "telegram" ? 1 : 0;
  },
  toName(id) {
    if (id && typeof id === "string") return id;
    return id == 1 ? "telegram" : "riot";
  }
};
